import validate from 'jquery-validation';
validate;

require('./contact/validatorCpf');
require('./contact/validatorBrazilianPhone');
require('./contact/validatorReclamacao');
require('./contact/contact-form');
